var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main__content statistics"},[_c('Table',{staticClass:"statistics__table",attrs:{"content":_vm.statistic_table}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }